export const HOME = "/";
export const MOVIE_DETAIL = "/movie/:id";
export const SEARCH = "/search";
